import type { Lang } from "@iyk/vf-app-config"

import * as UI from "@iyk/ui"
import * as React from "react"

import { Data } from "effect"
import { translations } from "./translations.ts"

type ResendOtpState = Data.TaggedEnum<{
  Idle: {}
  Sent: {}
}>

const ResendOtpState = Data.taggedEnum<ResendOtpState>()

export const ResendOtpCodeButton = ({ onOtpSent, lang }: ResendOtpCodeButton.Props) => {
  const [countdown, setCountdown] = React.useState(0)
  const t = translations[lang]

  const handleSendOtp = () => {
    setCountdown(4)
    onOtpSent()
  }

  React.useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000)
      return () => clearTimeout(timer)
    }
  }, [countdown])

  const state = countdown > 0 ? ResendOtpState.Sent() : ResendOtpState.Idle()

  return ResendOtpState.$match(state, {
    Idle: () => <IdleResendOtpCode handleSendOtp={handleSendOtp} text={t.ResendOtpCodeButton.idle.resend} />,
    Sent: () => <SentResendOtpCode text={t.ResendOtpCodeButton.sent.codeSent} />
  })
}

const IdleResendOtpCode = ({ handleSendOtp, text }: { handleSendOtp: () => void; text: string }) => {
  return (
    <UI.Button size="md" kind="ghost" className="w-full" type="button" onClick={handleSendOtp}>
      <UI.Icon.Rewatch />
      {text}
    </UI.Button>
  )
}

const SentResendOtpCode = ({ text }: { text: string }) => (
  <UI.Button size="md" kind="ghost" className="w-full" type="button">
    <UI.Icon.Check />
    {text}
  </UI.Button>
)

namespace ResendOtpCodeButton {
  export type Props = {
    onOtpSent: () => void
    lang: Lang
  }
}
